import { connect } from "react-redux";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Base } from "zina-dogi-react";
import swal from "sweetalert";
import { CpoListDetail, ItemTable } from "../components";
import * as Cpo from "../redux";
import * as Oet from "../../oet/redux";

class CpoDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            oetID: null
        };
    }

    componentDidMount() {
        this.update_or_init();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cpoID !== prevProps.cpoID || this.props.location !== prevProps.location) {
             this.update_or_init();
        }
    }

    update_or_init = (force = false) => {
        const { getCpoItems, cpoID, cpo, location, history } = this.props;
        
        if (force) {
            getCpoItems(cpoID);
            return;
        }

        if (!cpo || String(cpo.id) !== String(cpoID)) {
             getCpoItems(cpoID);
        } else if (Object.keys(cpo).length <= 2) {
             getCpoItems(cpoID);
        }

        if (history.action === "PUSH" && location.state && location.state.from === "importer") {
            const state = { ...location.state };
            delete state.from;
            history.replace(location.pathname, state);
        }
    };

    getUserPermisions = () => {
        const { user } = this.props;
        return user.groups.reduce((res, group) => {
            const permissions = group.permissions
                .map(permission => permission.codename)
                .filter(permission => !res.includes(permission));
            return [...res, ...permissions];
        }, []);
    };

    render() {
        let { cpo, loading, extraProps } = this.props;
        cpo = cpo || {};
        const base_op = {
            className: "cpo_list",
            title: `Customer purchase order ${cpo.number}`,
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: `CPO ${cpo.number}` }],
            extraProps,
            loading
        };
        const redirectUrl = `/tracker/${this.state.oetID}`;
        return (
            <div style={{ height: "100%" }}>
                {this.state.redirect && this.props.location.pathname !== redirectUrl && <Redirect to={redirectUrl} />}
                <Base {...base_op}>
                    <CpoListDetail
                        cpo={cpo}
                        onStartOET={this.onStartOET}
                        onMarkAsNonOetRelated={this.onMarkAsNonOetRelated}
                        cancelCPO={this.props.cancelCPO}
                        listCircles={this.props.listCircles}
                        update={() => {
                            const { cpoID, getCpoItems } = this.props;
                            getCpoItems(cpoID);
                        }}
                        isFinanceUser={this.getUserPermisions().includes("can_update_tcc_and_fandc_fields")}
                        changeTypeFlow={this.change_type_flow}
                        user={this.props.user}
                    />
                    <ItemTable items={cpo.cpo_items} cpo_id={cpo && cpo.id} cpo_number={cpo && cpo.number} cpo={cpo} />
                </Base>
            </div>
        );
    }

    change_type_flow = () => {
        const { cpo } = this.props;
        if (cpo && cpo.cpo_register) {
            Cpo.service
                .switch_bulk_and_sode_state(cpo.cpo_register.id)
                .then((data) => this.update_or_init(true))
                .catch(error => {
                    if (error && error.response && error.response.status === 400) {
                        const { response } = error;
                        if (response.data.detail) {
                            swal({
                                title: "Warning!",
                                text: response.data.detail,
                                icon: "warning",
                                timer: 3000,
                                button: true
                            });
                        }
                    }
                });
        }
    };

    onStartOET = (project, circle, stp_number) => {
        const { startOET, cpo } = this.props;
        const hasOet = cpo && cpo.oet && !Array.isArray(cpo.oet);
        const isTemporary = !!(hasOet && cpo.oet.temporary);
        if (cpo.oet && cpo.oet.id) {
            if (!isTemporary) {
                this.setState({
                    redirect: true,
                    oetID: cpo.oet.id
                });
            } else {
                Cpo.service
                    .startTemporaryOet(cpo.oet.id)
                    .then(() => {
                        this.setState({
                            redirect: true,
                            oetID: cpo.oet.id
                        });
                    })
                    .catch(error => {
                        let data = error.response.data;
                        swal({
                            title: "Warning",
                            text: data.detail,
                            icon: "warning",
                            button: true
                        });
                    });
            }
        } else {
            startOET(
                cpo.cpo_register.id,
                circle,
                project,
                oet => {
                    this.setState({
                        redirect: true,
                        oetID: oet.id
                    });
                },
                error => {
                    let data = error.response.data;
                    if (Array.isArray(data)) {
                        data = data.join("\n");
                    }
                    swal({
                        title: "Warning",
                        text: data,
                        icon: "warning",
                        button: true
                    });
                },
                stp_number
            );
        }
    };

    onMarkAsNonOetRelated = (id, number, ok, fail) => {
        const { markAsNonOetRelated } = this.props;
        markAsNonOetRelated(id, number, ok, fail);
    };
}

const mapStateToProps = (store, ownProps) => ({
    user: store.auth.user,
    cpoID: ownProps.match.params.cpoID,
    cpo: store.cpo.selectedCpo,
    cancellingSelectedCPO: store.cpo.cancellingSelectedCPO,
    loading: store.cpo.loading
});
const mapDispatchToProps = dispatch => ({
    getCpoItems: cpoID => dispatch(Cpo.actions.getCpoItems(cpoID)),
    startOET: (cpoRegisterID, circle, project, onOk, onFail, stp_number) =>
        dispatch(Oet.actions.createOetIn(cpoRegisterID, circle, project, onOk, onFail, stp_number)),
    oetS: newOet => dispatch(Oet.actions.createOetInSuccess(newOet)),
    markAsNonOetRelated: (id, number, ok = null, fail = null) =>
        dispatch(Cpo.actions.nonOetRelated(id, number, ok, fail)),
    cancelCPO: (cpoID, cpoNumber) => dispatch(Cpo.actions.cancelCPO(cpoID, cpoNumber)),
    listCircles: search => dispatch(Cpo.actions.listCircles(search))
});
export default connect(mapStateToProps, mapDispatchToProps)(CpoDetail);
